import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import useScrollToTop from "@/hooks/useScrollToTop";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "@/i18n";

export default function Layout({ children, onOpenCookies }) {
  useScrollToTop();
  const { i18n, t } = useTranslation();
  const { lang } = useParams();

  useEffect(() => {
    const active = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
    if (i18n.language !== active) i18n.changeLanguage(active);
    document.documentElement.lang = active === "ar" ? "es-AR" : "en";
    document.title = t("meta.title");
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", t("meta.description"));
  }, [lang, i18n, t]);

  return (
    <div className="min-h-screen flex flex-col bg-[#F7F3EA] text-[#0F1B2D]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer onOpenCookies={onOpenCookies} />
    </div>
  );
}
